/**
 * Generates time axis values aligned to round intervals
 * @param min - Minimum timestamp (in milliseconds)
 * @param max - Maximum timestamp (in milliseconds)
 * @param interval - Interval in milliseconds (e.g., 10 * 60 * 1000 for 10 minutes)
 * @returns Array of timestamps at round interval boundaries
 */
export const generateTimeAxisValues = (min: number, max: number, interval: number): number[] => {
  const values: number[] = [];
  const startOfDay = new Date(min).setHours(0, 0, 0, 0);
  let current = startOfDay + Math.ceil((min - startOfDay) / interval) * interval;
  while (current <= max) {
    values.push(current);
    current += interval;
  }
  return values;
};
